export default __webpack_public_path__ + "static/media/rangeoff-placeholder.733bde75.svg";